import { ToggleButton as MuiToggleButton, type ToggleButtonProps } from "@mui/material";
import { type FieldValues, type Path, useController } from "react-hook-form";
import { type ElementTracking, useElementTracking } from "../../../analytics/analytics";

export const CeToggleButton = <TFieldValues extends FieldValues>({
  name,
  analyticsCategory,
  ...props
}: {
  name: Path<TFieldValues>;
} & ElementTracking &
  Omit<ToggleButtonProps, "value" | "onChange">): React.JSX.Element => {
  const { field } = useController<TFieldValues>({ name });
  const analyticsProps = useElementTracking(analyticsCategory, name, "toggle");
  return (
    <MuiToggleButton
      selected={!!field.value}
      name={field.name}
      value={field.value}
      onChange={() => {
        field.onChange(!field.value);
      }}
      {...analyticsProps}
      {...props}
    />
  );
};
